module.exports = __webpack_public_path__ + "static/media/Dør.b366ede8.PNG";